module.exports = __webpack_public_path__ + "img/delete-icon.ab226acd.svg";